/* SafeS Pay Shopify A-site embedded checkout.
 * This file is generated for one B-site/store. Re-download it after changing the B-site.
 */
window.__SafeSPayEmbeddedCheckoutConfig = {
  "forceDirectProxy": true,
  "useWrapperPage": false,
  "wrapperPath": "/a/checkouts/a_index.html",
  "proxyPath": "/a/checkouts/a_index.html",
  "bSiteId": "66daeaa4-bd92-4561-bd83-52458243bbe5",
  "bsiteId": "66daeaa4-bd92-4561-bd83-52458243bbe5",
  "b_site_id": "66daeaa4-bd92-4561-bd83-52458243bbe5",
  "store": "piginto",
  "storeSlug": "piginto",
  "mallStoreOrigin": "https://nookstill.shop",
  "bSiteOrigin": "https://nookstill.shop",
  "mallLandingPage": "",
  "landingPage": "",
  "landing_page": "",
  "mallPaymentGatewayMode": "inherit",
  "paymentGatewayMode": "inherit",
  "mallPaymentGateways": [],
  "paymentGateways": [],
  "mallPaymentChannelIds": [
    "useepay"
  ],
  "paymentChannelIds": [
    "useepay"
  ],
  "payment_channel_ids": [
    "useepay"
  ],
  "mall_channel_ids": [
    "useepay"
  ],
  "mallPaymentChannelId": "useepay",
  "paymentChannelId": "useepay",
  "payment_channel_id": "useepay",
  "mall_channel_id": "useepay"
};

(function () {
  "use strict";
  // Retired positioning-only URLs must remain inert if Shopify caches an old script tag.
  try { if (document.currentScript && new URL(document.currentScript.src).searchParams.get("checkout_scroll") === "1") return; } catch (e) {}


  if (window.__SafeSPayEmbeddedACheckoutLoaded || window.__PigintoProductCheckoutLoaded) return;
  window.__SafeSPayEmbeddedACheckoutLoaded = true;
  window.__PigintoProductCheckoutLoaded = true;

  // BEGIN TIKTOK FUNNEL 20261021
/* Inlined into the downloaded embedded checkout asset; no payment or server events. */
function createEmbeddedTikTokFunnel(w, d, config) {
  "use strict";
  var rawFetch = w.fetch && w.fetch.bind(w);
  var pixels = [], ready = null, sequence = 0, seenCheckout = {}, installed = false;
  function enabled() {
    return config().tiktokFunnelTracking !== false && config().tiktokFunnelConsent !== false;
  }
  function sdk(id) {
    var q = w.ttq;
    if (!q) {
      w.TiktokAnalyticsObject = "ttq";
      q = w.ttq = [];
      q._i = {}; q._t = {}; q._o = {};
      var methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie", "holdConsent", "revokeConsent", "grantConsent"];
      function defer(target, name) { target[name] = function () { target.push([name].concat(Array.prototype.slice.call(arguments))); }; }
      methods.forEach(function (name) { defer(q, name); });
      q.instance = function (key) { return q._i[key]; };
      q.load = function (key) {
        var instance = q._i[key] = [];
        methods.forEach(function (name) { defer(instance, name); });
        q._t[key] = Date.now(); q._o[key] = {};
        var script = d.createElement("script"); script.async = true;
        script.src = "https://analytics.tiktok.com/i18n/pixel/events.js?sdkid=" + encodeURIComponent(key) + "&lib=ttq";
        instance._u = "https://analytics.tiktok.com/i18n/pixel/events.js";
        d.head.appendChild(script);
      };
    }
    if ((!q._i || !q._i[id]) && typeof q.load === "function") q.load(id);
    return q.instance && q.instance(id);
  }
  function preload() {
    if (!enabled() || !rawFetch) return Promise.resolve([]);
    if (ready) return ready;
    var endpoint = "https://safespay.app/api/public/asite-tracking?shop=" + encodeURIComponent(w.location.hostname);
    ready = rawFetch(endpoint, { credentials: "omit", mode: "cors", signal: AbortSignal.timeout(4000) })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!enabled() || !data || !data.matched) return [];
        pixels = (data.tiktokPixels || []).map(function (p) { return String(p.pixelId || "").trim(); })
          .filter(function (id, i, all) { return /^[A-Za-z0-9_-]{5,100}$/.test(id) && all.indexOf(id) === i; });
        pixels.forEach(sdk); return pixels;
      }).catch(function () { return []; });
    return ready;
  }
  function properties(items, currency) {
    if (!Array.isArray(items) || !items.length || !/^[A-Z]{3}$/.test(currency || "")) return null;
    var contents = items.map(function (item) {
      return { content_id: String(item.variant_id || item.id || item.vid || ""), content_name: String(item.product_title || item.title || ""),
        quantity: Number(item.quantity != null ? item.quantity : item.qty),
        price: Number(item.final_price != null ? item.final_price : item.price) / 100 };
    });
    if (contents.some(function (i) { return !i.content_id || !Number.isInteger(i.quantity) || i.quantity < 1 || !Number.isFinite(i.price) || i.price < 0; })) return null;
    return { contents: contents, content_type: "product", currency: currency,
      value: contents.reduce(function (sum, i) { return sum + Math.round(i.price * 100) * i.quantity; }, 0) / 100 };
  }
  function emit(name, props, id) {
    if (!enabled() || !props) return Promise.resolve();
    function dispatch() {
      if (!enabled()) return;
      pixels.forEach(function (pixel) {
        try { var instance = sdk(pixel); if (instance && instance.track) instance.track(name, props, { event_id: id }); } catch (e) {}
      });
    }
    if (pixels.length) { dispatch(); return Promise.resolve(); }
    return preload().then(dispatch).catch(function () {});
  }
  function addQuantities(body) {
    try {
      if (typeof body === "string") {
        try { return addQuantities(JSON.parse(body)); } catch (e) { body = new URLSearchParams(body); }
      }
      if (body && typeof body.get === "function") return [{ id: String(body.get("id") || ""), quantity: Number(body.get("quantity") || 1) }];
      if (body && Array.isArray(body.items)) return body.items;
      return body ? [{ id: String(body.id || ""), quantity: Number(body.quantity || 1) }] : [];
    } catch (e) { return []; }
  }
  function added(data, quantities) {
    var items = data && (Array.isArray(data.items) ? data.items : [data]);
    if (!items || !quantities.length) return;
    items = items.map(function (item) {
      var requested = quantities.filter(function (q) { return String(q.id) === String(item.variant_id || item.id); });
      return Object.assign({}, item, { quantity: requested.reduce(function (sum, q) { return sum + Number(q.quantity || 1); }, 0) });
    });
    var currency = w.Shopify && w.Shopify.currency && w.Shopify.currency.active;
    emit("AddToCart", properties(items, currency), "safes_add_" + Date.now() + "_" + (++sequence));
  }
  function isAdd(input, method) {
    try {
      var url = new URL(typeof input === "string" ? input : input.url, w.location.origin);
      return url.origin === w.location.origin && /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/cart\/add(?:\.js)?\/?$/i.test(url.pathname) && String(method || "GET").toUpperCase() === "POST";
    } catch (e) { return false; }
  }
  function install() {
    if (!enabled() || installed) return;
    installed = true;
    preload();
    if (rawFetch) {
      var original = w.fetch;
      w.fetch = function (input, options) {
        var matches = isAdd(input, options && options.method || input && input.method);
        if (matches) {
          var quantities;
          try { quantities = options && options.body != null ? Promise.resolve(addQuantities(options.body)) : input && input.clone ? input.clone().text().then(addQuantities) : Promise.resolve([]); }
          catch (e) { quantities = Promise.resolve([]); }
        }
        var result = original.apply(this, arguments);
        if (matches) {
          // Clone only; never consume or replace the response returned to the theme.
          result.then(function (response) {
            if (response.ok) Promise.all([response.clone().json(), quantities]).then(function (parts) { added(parts[0], parts[1]); }).catch(function () {});
          }).catch(function () {});
        }
        return result;
      };
    }
    var proto = w.XMLHttpRequest && w.XMLHttpRequest.prototype;
    if (proto) {
      var open = proto.open, send = proto.send, requests = new WeakMap();
      proto.open = function (method, url) { var result = open.apply(this, arguments); requests.set(this, isAdd(String(url), method)); return result; };
      proto.send = function () {
        var xhr = this;
        var quantities = addQuantities(arguments[0]);
        if (requests.get(xhr)) xhr.addEventListener("loadend", function () {
          if (xhr.status < 200 || xhr.status >= 300) return;
          try { added(xhr.responseType === "json" ? xhr.response : JSON.parse(xhr.responseText), quantities); } catch (e) {}
        }, { once: true });
        return send.apply(this, arguments);
      };
    }
  }
  function checkout(url) {
    try {
      if (!enabled() || seenCheckout[url]) return;
      var target = new URL(url, w.location.origin);
      var settings = config();
      var configuredPaths = [settings.proxyPath, settings.wrapperPath].filter(function (path) { return typeof path === "string" && path.charAt(0) === "/"; });
      if (target.origin !== w.location.origin || (!/^\/a\/checkouts\//.test(target.pathname) && configuredPaths.indexOf(target.pathname) < 0)) return;
      var raw = target.searchParams.get("payload") || "";
      var payload = JSON.parse(decodeURIComponent(escape(w.atob(raw.replace(/-/g, "+").replace(/_/g, "/")))));
      var props = properties(payload.i, payload.c);
      if (!props) return;
      seenCheckout[url] = true;
      // Initiation means a valid checkout redirect, not proof that the payment page loaded.
      emit("InitiateCheckout", props, "safes_checkout_" + Date.now() + "_" + (++sequence));
    } catch (e) {}
  }
  return { install: install, checkout: checkout };
}

  var tiktokFunnel = createEmbeddedTikTokFunnel(window, document, readConfig);
  // END TIKTOK FUNNEL 20261021

  var CHECKOUT_WRAPPER_PATH = "/a/checkouts/a_index.html";
  var LEGACY_CHECKOUT_WRAPPER_PATH = "/pages/piginto-checkout";
  var CHECKOUT_PROXY_PATH = "/a/checkouts/a_index.html";
  var VERSION = "20260815-never-native-guard";
  // 「点击结账」信标:买家在 A站点了结账/立即购买(触发跳转)时上报一次,埋点类型 a_checkout_click。
  // 用来量「点了却没到达我们结账页」的截流:点击数(a_checkout_click) vs 打开页数(other)/到达数(a_checkout)。
  // 走商城公开 tracking 端点(已放行 A站跨域);平台域名常量,若平台域名变了改这一行。
  var CLICK_TRACKING_ENDPOINT = "https://clampin.shop/api/tracking/pageview";
  var CLICK_BEACON_SESSION_KEY = "safespay.checkoutClickSid.v1";
  var checkoutClickBeaconFired = false;
  var ATTRIBUTION_STORAGE_KEY = "safespay.embeddedAttribution.v1";
  var ATTRIBUTION_PARAM_NAMES = [
    "gclid", "gbraid", "wbraid", "dclid", "msclkid", "gad_source", "gad_campaignid", "gad_campaign_id",
    "fbclid", "fbc", "fbp",
    "ttclid", "ttp",
    "utm_source", "utm_medium", "utm_campaign", "utm_id", "utm_term", "utm_content",
    "campaignid", "campaign_id"
  ];
  var cartCheckoutUrlCache = "";
  var cartCheckoutUrlPromise = null;
  var cartRewriteTimer = 0;

  function readJsonNode(id) {
    var node = document.getElementById(id);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || "{}");
    } catch (error) {
      return null;
    }
  }

  function readConfig() {
    var globalConfig = window.__SafeSPayEmbeddedCheckoutConfig;
    if (globalConfig && typeof globalConfig === "object" && !globalConfig.nodeType) return globalConfig;
    return readJsonNode("SafeSPayEmbeddedCheckoutConfig") || readJsonNode("PigintoProductCheckoutConfig") || {};
  }

  function readData() {
    return readJsonNode("SafeSPayEmbeddedCheckoutData") || readJsonNode("PigintoProductCheckoutData");
  }

  function configuredBsiteId(data) {
    var config = readConfig();
    return String(
      data && (data.bSiteId || data.bsiteId || data.b_site_id) ||
      config.targetBSiteId ||
      config.targetBsiteId ||
      config.bSiteId ||
      config.bsiteId ||
      config.b_site_id ||
      ""
    ).trim();
  }

  function configuredStore(data) {
    var config = readConfig();
    return String(
      data && (data.store || data.storeSlug || data.targetStore) ||
      config.store ||
      config.storeSlug ||
      config.targetStore ||
      ""
    ).trim();
  }

  function configuredMallLandingPage(data) {
    var config = readConfig();
    return String(
      data && (data.mallLandingPage || data.landingPage || data.landing_page || data.bSiteLandingPage) ||
      config.mallLandingPage ||
      config.landingPage ||
      config.landing_page ||
      config.bSiteLandingPage ||
      ""
    ).trim();
  }

  function normalizeGatewayList(value) {
    var raw = Array.isArray(value) ? value : String(value || "").split(/[,，\s]+/);
    var seen = {};
    return raw.map(function (item) {
      return String(item || "").trim().toLowerCase();
    }).filter(function (item) {
      if (!item || seen[item]) return false;
      seen[item] = true;
      return true;
    });
  }

  function configuredMallPaymentGateways(data) {
    var config = readConfig();
    return normalizeGatewayList(
      data && (data.mallPaymentGateways || data.paymentGateways || data.payment_gateways) ||
      config.mallPaymentGateways ||
      config.paymentGateways ||
      config.payment_gateways ||
      ""
    );
  }

  function normalizeChannelIdList(value) {
    var raw = Array.isArray(value) ? value : String(value || "").split(/[,，\s]+/);
    var seen = {};
    return raw.map(function (item) {
      return String(item || "").trim();
    }).filter(function (item) {
      if (!item || seen[item]) return false;
      seen[item] = true;
      return true;
    });
  }

  function configuredMallPaymentChannelIds(data) {
    var config = readConfig();
    var list = normalizeChannelIdList(
      data && (data.mallPaymentChannelIds || data.paymentChannelIds || data.payment_channel_ids || data.mall_channel_ids || data.channelIds) ||
      config.mallPaymentChannelIds ||
      config.paymentChannelIds ||
      config.payment_channel_ids ||
      config.mall_channel_ids ||
      config.channelIds ||
      ""
    );
    var single = String(
      data && (data.mallPaymentChannelId || data.paymentChannelId || data.payment_channel_id || data.mall_channel_id || data.channelId) ||
      config.mallPaymentChannelId ||
      config.paymentChannelId ||
      config.payment_channel_id ||
      config.mall_channel_id ||
      config.channelId ||
      ""
    ).trim();
    if (single && list.indexOf(single) < 0) list.unshift(single);
    return list;
  }

  function configuredMallPaymentChannelId(data) {
    return configuredMallPaymentChannelIds(data)[0] || "";
  }

  function configuredMallPaymentGatewayMode(data, gateways, channelId) {
    var config = readConfig();
    var value = String(
      data && (data.mallPaymentGatewayMode || data.paymentGatewayMode || data.payment_gateway_mode) ||
      config.mallPaymentGatewayMode ||
      config.paymentGatewayMode ||
      config.payment_gateway_mode ||
      ""
    ).trim().toLowerCase();
    if (value) return value;
    return (gateways && gateways.length) || channelId ? "selected" : "inherit";
  }

  function configuredASiteDomain() {
    var config = readConfig();
    return String(
      config.aSiteDomain ||
      config.configuredASiteDomain ||
      config.configured_a_site_domain ||
      window.location.hostname ||
      ""
    ).trim();
  }

  function cookieValue(name) {
    var target = String(name || "") + "=";
    var parts = String(document.cookie || "").split("; ");
    for (var i = 0; i < parts.length; i += 1) {
      if (parts[i].indexOf(target) === 0) return decodeURIComponent(parts[i].slice(target.length));
    }
    return "";
  }

  function normalizeAttributionAliases(result) {
    var aliases = {
      utm_source: "utmSource",
      utm_medium: "utmMedium",
      utm_campaign: "utmCampaign",
      utm_id: "utmId",
      utm_term: "utmTerm",
      utm_content: "utmContent",
      gad_source: "gadSource",
      gad_campaignid: "gadCampaignId",
      gad_campaign_id: "gadCampaignId",
      campaignid: "campaignId",
      campaign_id: "campaignId"
    };
    Object.keys(aliases).forEach(function (key) {
      var target = aliases[key];
      if (result[key] && !result[target]) result[target] = result[key];
    });
    return result;
  }

  function cleanAttributionObject(input) {
    var out = {};
    Object.keys(input || {}).forEach(function (key) {
      if (!key || key.charAt(0) === "_") return;
      var value = input[key];
      if (value === undefined || value === null || String(value) === "") return;
      out[key] = String(value).trim().slice(0, key === "sourceUrl" || key === "landingPage" || key === "referrer" ? 2000 : 1000);
    });
    return normalizeAttributionAliases(out);
  }

  function safeReadStoredAttribution() {
    try {
      var raw = window.localStorage && window.localStorage.getItem(ATTRIBUTION_STORAGE_KEY);
      if (!raw) return {};
      return cleanAttributionObject(JSON.parse(raw));
    } catch (error) {
      return {};
    }
  }

  function safeWriteStoredAttribution(value) {
    try {
      if (!window.localStorage) return;
      var clean = cleanAttributionObject(value);
      if (!hasAttributionSignal(clean)) return;
      clean._savedAt = new Date().toISOString();
      window.localStorage.setItem(ATTRIBUTION_STORAGE_KEY, JSON.stringify(clean));
    } catch (error) {
      // Browser privacy settings can block storage; checkout still carries current-page params.
    }
  }

  function hasAttributionSignal(input) {
    var data = input || {};
    return ATTRIBUTION_PARAM_NAMES.some(function (key) { return Boolean(data[key]); }) ||
      Boolean(
        data.utmSource || data.utmMedium || data.utmCampaign || data.utmId || data.utmTerm || data.utmContent ||
        data.gadSource || data.gadCampaignId || data.campaignId
      );
  }

  function currentAttributionParams() {
    var result = {};
    var params = new URL(window.location.href).searchParams;
    ATTRIBUTION_PARAM_NAMES.forEach(function (name) {
      var value = params.get(name);
      if (value) result[name] = value;
    });
    if (!result.fbp) result.fbp = cookieValue("_fbp");
    if (!result.fbc) result.fbc = cookieValue("_fbc");
    if (!result.ttp) result.ttp = cookieValue("_ttp");
    result.sourceUrl = window.location.href || "";
    result.referrer = document.referrer || "";
    result = cleanAttributionObject(result);
    if (hasAttributionSignal(result)) result.landingPage = result.landingPage || window.location.href || "";
    return result;
  }

  function collectAttributionParams() {
    var stored = safeReadStoredAttribution();
    var current = currentAttributionParams();
    var merged = cleanAttributionObject(Object.assign({}, stored, current));
    if (stored.landingPage && !hasAttributionSignal(current)) merged.landingPage = stored.landingPage;
    if (!merged.landingPage && hasAttributionSignal(merged)) merged.landingPage = current.sourceUrl || stored.sourceUrl || window.location.href || "";
    if (hasAttributionSignal(current) || hasAttributionSignal(stored)) safeWriteStoredAttribution(merged);
    return merged;
  }

  function publicAttributionParams(attribution) {
    var out = {};
    var aliases = {
      utmSource: "utm_source",
      utmMedium: "utm_medium",
      utmCampaign: "utm_campaign",
      utmId: "utm_id",
      utmTerm: "utm_term",
      utmContent: "utm_content",
      gadSource: "gad_source",
      gadCampaignId: "gad_campaignid",
      campaignId: "campaignid"
    };
    ATTRIBUTION_PARAM_NAMES.forEach(function (key) {
      if (attribution && attribution[key]) out[key] = attribution[key];
    });
    Object.keys(aliases).forEach(function (key) {
      var target = aliases[key];
      if (attribution && attribution[key] && !out[target]) out[target] = attribution[key];
    });
    return out;
  }

  function writeParams(url, params) {
    Object.keys(params || {}).forEach(function (key) {
      var value = params[key];
      if (value !== undefined && value !== null && String(value) !== "") {
        url.searchParams.set(key, String(value));
      }
    });
  }

  function normalizePath(value, fallback) {
    var path = String(value || fallback || "").trim();
    if (!path) path = fallback || "/";
    if (path.charAt(0) !== "/") path = "/" + path;
    return path.replace(/\/+$/, "") || "/";
  }

  function checkoutWrapperPath(data) {
    var config = readConfig();
    return normalizePath(data && data.wrapperPath || config.wrapperPath, CHECKOUT_WRAPPER_PATH);
  }

  function checkoutProxyPath() {
    var config = readConfig();
    return normalizePath(config.proxyPath || config.baseUrl, CHECKOUT_PROXY_PATH);
  }

  function boolValue(value, fallback) {
    if (value === undefined || value === null || value === "") return fallback;
    if (value === true || value === false) return value;
    var text = String(value || "").trim().toLowerCase();
    if (!text) return fallback;
    if (text === "0" || text === "false" || text === "no" || text === "off") return false;
    if (text === "1" || text === "true" || text === "yes" || text === "on") return true;
    return fallback;
  }

  function forceDirectProxy(data) {
    var config = readConfig();
    var value = data && data.forceDirectProxy;
    if (value === undefined || value === null || value === "") value = config.forceDirectProxy;
    return boolValue(value, true);
  }

  function useWrapperPage(data) {
    if (forceDirectProxy(data)) return false;
    var config = readConfig();
    var value = data && data.useWrapperPage;
    if (value === undefined || value === null || value === "") value = config.useWrapperPage;
    if (value === undefined || value === null || value === "") value = config.wrapperMode;
    if (value === true) return true;
    value = String(value || "").trim().toLowerCase();
    return value === "page" || value === "wrapper" || value === "legacy";
  }

  function checkoutLandingPath(data) {
    return useWrapperPage(data) ? checkoutWrapperPath(data) : checkoutProxyPath();
  }

  function normalizeUrl(value) {
    var url = String(value || "").trim();
    if (!url) return "";
    if (url.indexOf("//") === 0) return window.location.protocol + url;
    if (url.charAt(0) === "/") return window.location.origin + url;
    return url;
  }

  function base64UrlEncode(text) {
    var bytes = new TextEncoder().encode(text);
    var binary = "";
    for (var i = 0; i < bytes.length; i += 1) binary += String.fromCharCode(bytes[i]);
    return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
  }

  function productForm(root) {
    return (root || document).querySelector('form[action*="/cart/add"]');
  }

  function selectedVariantId(data, root) {
    var form = productForm(root);
    var input = form && form.querySelector('[name="id"]') || (root || document).querySelector('[name="id"]');
    var fromBundle = selectedBundleVariantIds(root)[0] || "";
    var fromInput = input && input.value;
    var fromUrl = new URL(window.location.href).searchParams.get("variant");
    return String(fromBundle || fromInput || fromUrl || data && data.selectedVariantId || "");
  }

  function selectedVariant(data, root) {
    var variants = Array.isArray(data && data.variants) ? data.variants : [];
    var id = selectedVariantId(data, root);
    return variants.find(function (variant) {
      return String(variant.id) === id;
    }) || variants[0] || null;
  }

  function selectedQuantity(root) {
    var bundleQty = quantityFromBundle(root);
    if (bundleQty > 1) return bundleQty;

    var form = productForm(root);
    var input = form && form.querySelector('[name="quantity"]') || (root || document).querySelector('[name="quantity"]');
    var qty = Number(input && input.value || 0);
    return qty > 0 ? Math.floor(qty) : 1;
  }

  function quantityFromBundle(root) {
    var label = selectedQuantityBreak(root);
    var attrQty = Number(label && label.getAttribute && label.getAttribute("data-quantity") || 0);
    if (attrQty > 0) return Math.floor(attrQty);
    var text = label && (label.innerText || label.textContent) || "";
    var match = text.match(/buy\s*(\d+)/i) || text.match(/买\s*(\d+)/i);
    return match ? Number(match[1]) || 1 : 1;
  }

  function labelForInput(input, scope) {
    if (!input || !input.id || !scope || !scope.querySelectorAll) return null;
    var labels = scope.querySelectorAll("label");
    for (var i = 0; i < labels.length; i += 1) {
      if (labels[i].getAttribute("for") === input.id) return labels[i];
    }
    return null;
  }

  function elementText(node) {
    return node && (node.innerText || node.textContent || "") || "";
  }

  function looksLikeQuantityBreak(node) {
    var text = elementText(node);
    if (!text || !moneyCandidatesFromText(text).length) return false;
    return /buy\s*\d+|购买\s*\d+|bundle|save|you\s*save|quantity|套餐|件|pcs|折扣|节省/i.test(text);
  }

  function selectedQuantityBreak(root) {
    var scopes = [];
    if (root && root.querySelector) scopes.push(root);
    if (document && root !== document) scopes.push(document);
    for (var i = 0; i < scopes.length; i += 1) {
      var scope = scopes[i];
      var checked = scope.querySelector('quantity-breaks input[type="radio"][name="quantity"]:checked, input[type="radio"][name="quantity"]:checked');
      if (!checked) continue;
      var label = labelForInput(checked, scope) || labelForInput(checked, document) || checked.closest && checked.closest("label") || checked.nextElementSibling;
      var card = checked.closest && checked.closest("label, [data-quantity], .quantity-break, [class*='quantity'], [class*='bundle'], [class*='break'], [class*='offer']");
      var candidates = [label, card, checked.parentElement];
      for (var j = 0; j < candidates.length; j += 1) {
        var candidate = candidates[j];
        if (!candidate || !candidate.matches) continue;
        if (candidate.matches(".quantity-break, [data-quantity]") || candidate.querySelector(".quantity-break__price, [class*='quantity-break__price']") || looksLikeQuantityBreak(candidate)) return candidate;
      }
    }
    return null;
  }

  function selectedBundleVariantIds(root) {
    var label = selectedQuantityBreak(root);
    if (!label || !label.querySelectorAll) return [];
    var ids = [];
    var items = label.querySelectorAll("[data-selected-id], .quantity-break__selector-item");
    for (var i = 0; i < items.length; i += 1) {
      var id = String(items[i].getAttribute("data-selected-id") || "").trim();
      if (id) ids.push(id);
    }
    if (!ids.length) {
      var select = label.querySelector("[data-product-id]");
      var selectId = String(select && select.getAttribute("data-product-id") || "").trim();
      if (selectId) ids.push(selectId);
    }
    return ids;
  }

  function selectedBundleTotalCents(root) {
    var label = selectedQuantityBreak(root);
    if (!label || !label.querySelector) return 0;
    return bestPriceFromElement(label);
  }

  function closestTextBlock(node) {
    var block = node && node.closest("label, .bundle, .bundle-option, .option, .product-form__input, div");
    return block ? block.innerText || block.textContent || "" : "";
  }

  function variantTitle(data, variant) {
    var title = String(data && data.productTitle || "Item");
    var optionTitle = String(variant && variant.title || "").trim();
    if (optionTitle && optionTitle !== "Default Title") title += " - " + optionTitle;
    return title;
  }

  function currencyCode(data) {
    return data && data.currency || window.Shopify && window.Shopify.currency && window.Shopify.currency.active || "USD";
  }

  function payloadHasPricedItems(payload) {
    var items = Array.isArray(payload && payload.i) ? payload.i : [];
    return items.some(function (item) {
      return Number(item && item.qty || 0) > 0 && Number(item && item.price || 0) > 0;
    });
  }

  function checkoutUrlFromPayload(payload, source, data, options) {
    options = options || {};
    payload = payload && typeof payload === "object" ? payload : { c: "USD", i: [] };
    if (!payloadHasPricedItems(payload)) return "";
    var url = new URL(checkoutLandingPath(data), window.location.origin);
    var bSiteId = configuredBsiteId(data);
    var storeSlug = configuredStore(data);
    var mallLandingPage = configuredMallLandingPage(data);
    var mallPaymentGateways = configuredMallPaymentGateways(data);
    var mallPaymentChannelIds = configuredMallPaymentChannelIds(data);
    var mallPaymentChannelId = mallPaymentChannelIds[0] || "";
    var mallPaymentGatewayMode = configuredMallPaymentGatewayMode(data, mallPaymentGateways, mallPaymentChannelId);
    var currentUrl = options.sourceUrl || window.location.href || "";
    var returnUrl = options.returnUrl || currentUrl;
    var shopHost = window.location.hostname || "";
    var configuredDomain = configuredASiteDomain();
    var attribution = collectAttributionParams();
    if (bSiteId) {
      payload.bSiteId = payload.bSiteId || bSiteId;
      payload.bsiteId = payload.bsiteId || bSiteId;
      payload.b_site_id = payload.b_site_id || bSiteId;
      url.searchParams.set("bSiteId", bSiteId);
      url.searchParams.set("bsiteId", bSiteId);
      url.searchParams.set("b_site_id", bSiteId);
    }
    if (storeSlug) {
      payload.store = payload.store || storeSlug;
      payload.storeSlug = payload.storeSlug || storeSlug;
      url.searchParams.set("store", storeSlug);
    }
    if (mallLandingPage) {
      payload.mallLandingPage = payload.mallLandingPage || mallLandingPage;
      payload.landingPage = payload.landingPage || mallLandingPage;
      payload.landing_page = payload.landing_page || mallLandingPage;
      url.searchParams.set("mall_landing_page", mallLandingPage);
      url.searchParams.set("mallLandingPage", mallLandingPage);
      url.searchParams.set("landing_page", mallLandingPage);
      url.searchParams.set("landingPage", mallLandingPage);
    }
    if (mallPaymentGatewayMode && mallPaymentGatewayMode !== "inherit") {
      payload.mallPaymentGatewayMode = payload.mallPaymentGatewayMode || mallPaymentGatewayMode;
      payload.paymentGatewayMode = payload.paymentGatewayMode || mallPaymentGatewayMode;
      url.searchParams.set("mall_payment_gateway_mode", mallPaymentGatewayMode);
      url.searchParams.set("payment_gateway_mode", mallPaymentGatewayMode);
      url.searchParams.set("paymentGatewayMode", mallPaymentGatewayMode);
    }
    if (mallPaymentGateways.length) {
      payload.mallPaymentGateways = payload.mallPaymentGateways || mallPaymentGateways;
      payload.paymentGateways = payload.paymentGateways || mallPaymentGateways;
      url.searchParams.set("mall_payment_gateways", mallPaymentGateways.join(","));
      url.searchParams.set("payment_gateways", mallPaymentGateways.join(","));
      url.searchParams.set("paymentGateways", mallPaymentGateways.join(","));
    }
    if (mallPaymentChannelId) {
      payload.mallPaymentChannelIds = payload.mallPaymentChannelIds || mallPaymentChannelIds;
      payload.paymentChannelIds = payload.paymentChannelIds || mallPaymentChannelIds;
      payload.payment_channel_ids = payload.payment_channel_ids || mallPaymentChannelIds;
      payload.mall_channel_ids = payload.mall_channel_ids || mallPaymentChannelIds;
      payload.mallPaymentChannelId = payload.mallPaymentChannelId || mallPaymentChannelId;
      payload.paymentChannelId = payload.paymentChannelId || mallPaymentChannelId;
      payload.payment_channel_id = payload.payment_channel_id || mallPaymentChannelId;
      payload.mall_channel_id = payload.mall_channel_id || mallPaymentChannelId;
      url.searchParams.set("mall_channel_ids", mallPaymentChannelIds.join(","));
      url.searchParams.set("mallPaymentChannelIds", mallPaymentChannelIds.join(","));
      url.searchParams.set("payment_channel_ids", mallPaymentChannelIds.join(","));
      url.searchParams.set("paymentChannelIds", mallPaymentChannelIds.join(","));
      url.searchParams.set("mall_channel_id", mallPaymentChannelId);
      url.searchParams.set("mallPaymentChannelId", mallPaymentChannelId);
      url.searchParams.set("payment_channel_id", mallPaymentChannelId);
      url.searchParams.set("paymentChannelId", mallPaymentChannelId);
      url.searchParams.set("channel_id", mallPaymentChannelId);
    }
    payload.source = Object.assign({}, payload.source || {}, {
      type: "shopify_embedded_checkout",
      source: source || "shopify_theme",
      shop: shopHost,
      sourceUrl: currentUrl,
      returnUrl: returnUrl,
      aSiteDomain: shopHost,
      configuredASiteDomain: configuredDomain,
      openMode: "iframe",
      bSiteId: bSiteId,
      forceDirectProxy: forceDirectProxy(data),
      mallLandingPage: mallLandingPage,
      paymentGatewayMode: mallPaymentGatewayMode,
      paymentGateways: mallPaymentGateways,
      paymentChannelIds: mallPaymentChannelIds,
      paymentChannelId: mallPaymentChannelId
    });
    payload.attribution = Object.assign({}, attribution, payload.attribution || {});
    payload.adParams = Object.assign({}, attribution, payload.adParams || {});
    writeParams(url, publicAttributionParams(attribution));
    writeParams(url, {
      currency: payload.c || "USD",
      embed: "shopify",
      start: "top",
      source: source || "shopify_theme",
      shop: shopHost,
      source_url: currentUrl,
      return_url: returnUrl,
      a_site_domain: shopHost,
      configured_a_site_domain: configuredDomain,
      open_mode: "iframe",
      force_direct_proxy: forceDirectProxy(data) ? "1" : "0",
      landing: useWrapperPage(data) ? "wrapper" : "proxy"
    });
    url.searchParams.set("v", VERSION);
    url.searchParams.set("payload", base64UrlEncode(JSON.stringify(payload)));
    return url.toString();
  }

  function checkoutUrlFromProductData(data, root, options) {
    options = options || {};
    var variant = selectedVariant(data, root);
    if (!variant) return "";
    var qty = selectedQuantity(root);
    var bundleTotalCents = selectedBundleTotalCents(root);
    var bundleVariantIds = selectedBundleVariantIds(root);
    var domTotalCents = bundleTotalCents || priceFromDom(root);
    var variantCents = priceValueToCents(variant.price);
    var totalCents = domTotalCents || (variantCents && qty > 0 ? variantCents * qty : 0);
    var unitCents = totalCents && qty > 0
      ? Math.max(1, Math.round(totalCents / qty))
      : variantCents;
    if (!unitCents) return "";
    var variants = Array.isArray(data && data.variants) ? data.variants : [];
    var lineMap = {};
    var lineOrder = [];
    var ids = bundleVariantIds.length ? bundleVariantIds.slice(0, qty) : [String(variant.id || "")];
    while (ids.length < qty) ids.push(ids[0] || String(variant.id || ""));
    ids.forEach(function (id) {
      var lineVariant = variants.find(function (item) {
        return String(item.id) === String(id);
      }) || variant;
      var key = String(lineVariant.id || id || "item");
      if (!lineMap[key]) {
        lineMap[key] = {
          sku: lineVariant.sku || String(lineVariant.id || key || "item"),
          vid: String(lineVariant.id || ""),
          pid: String(data.productId || ""),
          title: variantTitle(data, lineVariant),
          qty: 0,
          price: unitCents,
          imageUrl: normalizeUrl(lineVariant.imageUrl || data.productImageUrl)
        };
        lineOrder.push(key);
      }
      lineMap[key].qty += 1;
    });
    var payload = {
      c: currencyCode(data),
      i: lineOrder.map(function (key) {
        return lineMap[key];
      })
    };
    if (totalCents) {
      payload.subtotalCents = totalCents;
      payload.amountCents = totalCents;
      payload.bundleQuantity = qty;
      payload.bundleUnitCents = unitCents;
      payload.priceSource = bundleTotalCents ? "bundle_dom" : (domTotalCents ? "dom_price" : "shopify_variant");
    }
    return checkoutUrlFromPayload(payload, options.sourceName || "shopify_theme_product", data, options);
  }

  function checkoutUrlFromCartData(cart, options) {
    var items = Array.isArray(cart && cart.items) ? cart.items : [];
    var lines = items.map(function (item) {
      var variantTitleText = String(item.variant_title || "").trim();
      var title = String(item.product_title || item.title || "Item").trim();
      if (variantTitleText && variantTitleText !== "Default Title" && title.indexOf(variantTitleText) === -1) {
        title += " - " + variantTitleText;
      }
      return {
        sku: item.sku || String(item.variant_id || item.id || "shopify-item"),
        vid: String(item.variant_id || item.id || ""),
        pid: String(item.product_id || ""),
        title: title,
        qty: Math.max(1, Math.floor(Number(item.quantity || 1))),
        price: Number(item.final_price || item.price || 0),
        imageUrl: normalizeUrl(item.image || item.featured_image && item.featured_image.url || "")
      };
    }).filter(function (item) {
      return item.qty > 0;
    });
    if (!lines.length) return "";
    return checkoutUrlFromPayload({
      c: cart.currency || currencyCode(null),
      i: lines
    }, "shopify_theme_cart", readData() || {}, options);
  }

  function fetchCartCheckoutUrl(options) {
    return fetch("/cart.js", {
      credentials: "same-origin",
      headers: { "Accept": "application/json" }
    }).then(function (response) {
      if (!response.ok) throw new Error("cart_" + response.status);
      return response.json();
    }).then(function (cart) {
      return checkoutUrlFromCartData(cart, options);
    });
  }

  function cachedCartCheckoutUrl() {
    if (cartCheckoutUrlCache) return Promise.resolve(cartCheckoutUrlCache);
    if (cartCheckoutUrlPromise) return cartCheckoutUrlPromise;
    cartCheckoutUrlPromise = fetchCartCheckoutUrl().then(function (url) {
      cartCheckoutUrlCache = url || "";
      cartCheckoutUrlPromise = null;
      return cartCheckoutUrlCache;
    }).catch(function (error) {
      cartCheckoutUrlPromise = null;
      throw error;
    });
    return cartCheckoutUrlPromise;
  }

  function warmCartCheckoutUrl() {
    cachedCartCheckoutUrl().then(function () {
      rewriteCartCheckoutControls();
    }).catch(function () {});
  }

  function invalidateCartCheckoutUrl() {
    cartCheckoutUrlCache = "";
    cartCheckoutUrlPromise = null;
  }

  function moneyCandidatesFromText(text) {
    var matches = String(text || "").match(/(?:[$€£]|USD|CAD|AUD|EUR|GBP)\s*[0-9][0-9,]*(?:[.,][0-9]{1,2})?|[0-9][0-9,]*[.,][0-9]{2}/ig);
    if (!matches || !matches.length) return [];
    return matches.map(function (match) {
      var clean = String(match).replace(/[^0-9.,]/g, "");
      if (!clean) return 0;
      if (clean.indexOf(",") >= 0 && clean.indexOf(".") >= 0) {
        clean = clean.replace(/,/g, "");
      } else {
        clean = clean.replace(",", ".");
      }
      var value = Number(clean);
      return value > 0 ? Math.round(value * 100) : 0;
    }).filter(function (value) {
      return value > 0;
    });
  }

  function parseMoneyToCents(text) {
    var candidates = moneyCandidatesFromText(text);
    return candidates[0] || 0;
  }

  function stripSavingsText(text) {
    var amount = "(?:[$€£]|USD|CAD|AUD|EUR|GBP)?\\s*[0-9][0-9,]*(?:[.,][0-9]{1,2})?";
    return String(text || "")
      .replace(new RegExp("(?:you\\s*)?(?:save|saved|saves|saving)[^$€£0-9]*(?:" + amount + ")", "ig"), " ")
      .replace(new RegExp("(?:您节省了?|节省|省下?|省|优惠|折扣)[^$€£0-9]*(?:" + amount + ")", "ig"), " ")
      .replace(/\d+\s*%\s*(?:off|折扣)/ig, " ");
  }

  function smallestMoneyToCents(text) {
    var candidates = moneyCandidatesFromText(stripSavingsText(text)).sort(function (a, b) {
      return a - b;
    });
    return candidates[0] || 0;
  }

  function isCompareOrSavingsNode(node) {
    if (!node) return false;
    if (node.closest && node.closest("s, del, strike")) return true;
    var marker = [
      node.className,
      node.id,
      node.getAttribute && node.getAttribute("aria-label"),
      node.getAttribute && node.getAttribute("data-testid"),
      elementText(node)
    ].filter(Boolean).join(" ").toLowerCase();
    return /compare|regular|was-price|old-price|original|strike|save|saving|you save|discount|off|节省|折扣|原价/.test(marker);
  }

  function bestPriceFromElement(root) {
    if (!root || !root.querySelectorAll) return 0;
    var selectors = [
      ".quantity-break__price",
      "[class*='quantity-break'][class*='price']",
      "[class*='bundle'][class*='price']",
      "[data-final-price]",
      "[data-sale-price]",
      "[data-price]",
      ".price-item--sale",
      ".price__sale .price-item",
      ".money",
      "[class*='price']"
    ].join(",");
    var values = [];
    var nodes = root.querySelectorAll(selectors);
    for (var i = 0; i < nodes.length; i += 1) {
      var node = nodes[i];
      if (isCompareOrSavingsNode(node)) continue;
      var attrValue = node.getAttribute && (node.getAttribute("data-final-price") || node.getAttribute("data-sale-price") || node.getAttribute("data-price"));
      var attrCents = priceValueToCents(attrValue);
      if (attrCents) values.push(attrCents);
      var textCents = smallestMoneyToCents(elementText(node));
      if (textCents) values.push(textCents);
    }
    if (values.length) {
      values.sort(function (a, b) {
        return a - b;
      });
      return values[0] || 0;
    }
    return smallestMoneyToCents(elementText(root));
  }

  function priceValueToCents(value) {
    if (value === undefined || value === null || value === "") return 0;
    if (typeof value === "number") {
      if (!isFinite(value) || value <= 0) return 0;
      if (Math.round(value) !== value || value < 100) return Math.round(value * 100);
      return Math.round(value);
    }

    var text = String(value || "").trim();
    if (!text) return 0;
    var clean = text.replace(/[^0-9.,-]/g, "").replace(",", ".");
    var numeric = Number(clean);
    if (!isFinite(numeric) || numeric <= 0) return 0;
    if (/[$€£]|[.,]\d{1,2}\b/.test(text) || numeric < 100) return Math.round(numeric * 100);
    return Math.round(numeric);
  }

  function contextFromButton(button) {
    return button.closest('[role="dialog"], dialog, .modal, .quick-add-modal, .quick-view, .drawer, section, main') || document.body;
  }

  function titleFromDom(root) {
    var node = root.querySelector("[data-product-title], .product__title, .product-title, h1, h2, h3");
    var text = node && (node.innerText || node.textContent || "").trim();
    if (text && !/bundle|save|description|share/i.test(text)) return text;
    return (document.title || "Shopify item").replace(/\s*[|-].*$/, "").trim() || "Shopify item";
  }

  function imageFromDom(root) {
    var img = root.querySelector("img");
    return normalizeUrl(img && (img.currentSrc || img.src || img.getAttribute("src")) || "");
  }

  function priceFromDom(root) {
    var bundleCents = selectedBundleTotalCents(root);
    if (bundleCents) return bundleCents;
    var checked = root.querySelector('input[type="radio"]:checked');
    var checkedCard = checked && (checked.closest && checked.closest("label, [class*='quantity'], [class*='bundle'], [class*='break'], [class*='offer']"));
    var cents = bestPriceFromElement(checkedCard);
    if (cents) return cents;
    return bestPriceFromElement(root);
  }

  function checkoutUrlFromDom(root) {
    var qty = selectedQuantity(root);
    var totalCents = priceFromDom(root);
    var unitCents = qty > 1 && totalCents ? Math.round(totalCents / qty) : totalCents;
    if (!unitCents) return "";
    var variantId = selectedVariantId(null, root);
    var payload = {
      c: currencyCode(null),
      i: [{
        sku: variantId || "shopify-item",
        vid: variantId || "",
        title: titleFromDom(root),
        qty: qty,
        price: unitCents || 0,
        imageUrl: imageFromDom(root)
      }]
    };
    if (totalCents) {
      payload.subtotalCents = totalCents;
      payload.amountCents = totalCents;
      payload.priceSource = "dom_price";
    }
    return checkoutUrlFromPayload(payload, "shopify_quick_buy", readData() || {});
  }

  function injectStyle() {
    if (document.getElementById("PigintoProductCheckoutStyle")) return;
    var style = document.createElement("style");
    style.id = "PigintoProductCheckoutStyle";
    style.textContent = [
      // Embedded stores route every payment through the embedded checkout, so Shopify's native
      // express / dynamic checkout buttons (Shop Pay, PayPal express, etc.) must never be reachable:
      // their clicks happen inside a cross-origin iframe and cannot be intercepted, so hide them.
      ".shopify-payment-button,.shopify-payment-button__button,.dynamic-checkout__content,[data-shopify='dynamic-checkout-cart'],.additional-checkout-buttons{display:none!important;}",
      ".piginto-product-checkout-shell{width:100%;max-width:1280px;margin:28px auto 0;background:#fff;clear:both;}",
      ".piginto-product-checkout-shell iframe{display:block;width:100%;min-height:1250px;border:0;background:#fff;}",
      ".piginto-checkout-wrapper{width:100%;max-width:1280px;margin:0 auto;background:#fff;}",
      ".piginto-checkout-wrapper iframe{display:block;width:100%;height:1800px;min-height:1350px;border:0;background:#fff;}",
      ".safes-embedded-checkout-frame-wrap{position:relative;min-height:760px;background:#fff;}",
      ".safes-embedded-checkout-loader{position:absolute;inset:0;z-index:5;display:flex;align-items:flex-start;justify-content:center;background:#fff;padding-top:168px;color:#1f2937;font:600 15px/1.4 -apple-system,BlinkMacSystemFont,'Segoe UI',Arial,sans-serif;}",
      ".safes-embedded-checkout-loader-card{display:flex;gap:12px;align-items:center;border:1px solid #e5e7eb;border-radius:12px;background:#fff;box-shadow:0 14px 34px rgba(15,23,42,.12);padding:16px 18px;}",
      ".safes-embedded-checkout-spinner{width:18px;height:18px;border:2px solid #d1d5db;border-top-color:#2563eb;border-radius:50%;animation:safesCheckoutSpin .8s linear infinite;}",
      "@keyframes safesCheckoutSpin{to{transform:rotate(360deg)}}",
      ".safes-embedded-checkout-loaded .safes-embedded-checkout-loader{opacity:0;visibility:hidden;transition:opacity .18s ease,visibility .18s ease;}",
      ".safes-checkout-transition-mask{position:fixed;inset:0;z-index:2147483647;display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,.72);backdrop-filter:blur(3px);-webkit-backdrop-filter:blur(3px);font:600 15px/1.4 -apple-system,BlinkMacSystemFont,'Segoe UI',Arial,sans-serif;color:#172033;}",
      ".safes-checkout-transition-card{display:flex;gap:12px;align-items:center;background:#fff;border:1px solid #e5e7eb;border-radius:12px;box-shadow:0 18px 48px rgba(15,23,42,.18);padding:16px 20px;}",
      ".piginto-product-checkout-message{padding:14px;border:1px solid #dbe3ef;border-radius:8px;background:#fff;color:#172033;font:14px/1.5 -apple-system,BlinkMacSystemFont,'Segoe UI',Arial,sans-serif;}",
      "body.piginto-checkout-theme-page .announcement-bar,body.piginto-checkout-theme-page .announcement-bar-section,body.piginto-checkout-theme-page [id*='announcement'],body.piginto-checkout-theme-page header nav,body.piginto-checkout-theme-page header .header__inline-menu,body.piginto-checkout-theme-page header .header__menu,body.piginto-checkout-theme-page header .menu,body.piginto-checkout-theme-page header .menu-list,body.piginto-checkout-theme-page header .header__drawer,body.piginto-checkout-theme-page header .header__search,body.piginto-checkout-theme-page header .header__icon--search,body.piginto-checkout-theme-page header .header__icon--account,body.piginto-checkout-theme-page header a[href*='/search'],body.piginto-checkout-theme-page header a[href*='/account'],body.piginto-checkout-theme-page header button[aria-label*='Search'],body.piginto-checkout-theme-page header button[aria-label*='搜索'],body.piginto-checkout-theme-page header button[aria-label*='Account'],body.piginto-checkout-theme-page header button[aria-label*='账户']{display:none!important;}",
      "body.piginto-checkout-theme-page .shopify-section-group-header-group,body.piginto-checkout-theme-page header{border-bottom:1px solid #d9d9d9!important;}",
      "body.piginto-checkout-theme-page header{min-height:72px!important;}",
      "body.piginto-checkout-theme-page header .header,body.piginto-checkout-theme-page header .header__inner,body.piginto-checkout-theme-page header .header-wrapper,body.piginto-checkout-theme-page header .page-width{display:flex!important;align-items:center!important;justify-content:space-between!important;}",
      "body.piginto-checkout-theme-page header .header__heading,body.piginto-checkout-theme-page header .header__heading-link,body.piginto-checkout-theme-page header .site-header__logo,body.piginto-checkout-theme-page header .header-logo{display:flex!important;align-items:center!important;}",
      "body.piginto-checkout-theme-page header .header__icons,body.piginto-checkout-theme-page header .site-header__icons{display:flex!important;align-items:center!important;margin-left:auto!important;}",
      "body.piginto-checkout-theme-page header .header__icons > *:not(.header__icon--cart):not([href*='/cart']):not(cart-icon):not(cart-drawer-opener){display:none!important;}",
      "body.piginto-checkout-theme-page footer,body.piginto-checkout-theme-page .footer,body.piginto-checkout-theme-page [id*='shopify-section-footer'],body.piginto-checkout-theme-page [id*='footer'],body.piginto-checkout-theme-page .shopify-section-group-footer-group,body.piginto-checkout-theme-page .footer-group,body.piginto-checkout-theme-page [class*='footer'],body.piginto-checkout-theme-page .scroll-to-top-btn,body.piginto-checkout-theme-page [id*='scroll-to-top']{display:none!important;}",
      "@media(max-width:749px){.piginto-product-checkout-shell{margin-top:22px}.piginto-product-checkout-shell iframe,.piginto-checkout-wrapper iframe{height:2200px;min-height:1550px;}}"
    ].join("");
    document.head.appendChild(style);
  }

  function insertAfter(reference, node) {
    if (!reference || !reference.parentNode) {
      (document.querySelector("main") || document.body).appendChild(node);
      return;
    }
    reference.parentNode.insertBefore(node, reference.nextSibling);
  }

  function createMount() {
    var existing = document.getElementById("PigintoProductCheckout");
    if (existing) return existing;
    var mount = document.createElement("section");
    mount.id = "PigintoProductCheckout";
    mount.className = "piginto-product-checkout-shell";
    var form = productForm(document);
    var section = form && form.closest('[id^="shopify-section-"], .shopify-section, section');
    insertAfter(section || form, mount);
    return mount;
  }

  var lastUrl = "";
  var frame = null;

  function updateProductPageFrame() {
    var data = readData();
    if (!data || !Array.isArray(data.variants) || !data.variants.length) return;

    var mount = createMount();
    var nextUrl = checkoutUrlFromProductData(data, document);
    if (!nextUrl) return;

    if (!frame || !frame.parentNode) {
      mount.textContent = "";
      frame = document.createElement("iframe");
      frame.title = "Secure Checkout";
      frame.loading = "eager";
      frame.allow = "payment *; clipboard-read; clipboard-write; fullscreen";
      frame.referrerPolicy = "strict-origin-when-cross-origin";
      mount.appendChild(frame);
    }

    if (nextUrl !== lastUrl) {
      lastUrl = nextUrl;
      frame.src = nextUrl;
    }
  }

  function isBuyNowButton(button) {
    if (!isButtonLikeAction(button)) return false;
    if (button.matches && button.matches("[data-safes-pay-buy-now]")) return true;
    var text = actionText(button);
    if (!text) return false;
    var className = String(button && button.className || "");
    return /立\s*即\s*购\s*买/i.test(text) ||
      /马\s*上\s*购\s*买/i.test(text) ||
      /立\s*刻\s*购\s*买/i.test(text) ||
      text.indexOf("buy now") !== -1 ||
      text.indexOf("buy it now") !== -1 ||
      text === "checkout" ||
      text.indexOf("express checkout") !== -1 ||
      className.indexOf("shopify-payment-button") !== -1 ||
      className.indexOf("buy-now") !== -1 ||
      className.indexOf("dynamic-checkout") !== -1;
  }

  function isButtonLikeAction(node) {
    if (!node || !node.matches) return false;
    if (node.matches("[data-safes-pay-buy-now], [data-safes-pay-button], [data-piginto-cart-checkout]")) return true;
    if (node.matches("button, input[type='submit'], input[type='button'], [role='button']")) return true;
    var className = String(node.className || "");
    return className.indexOf("shopify-payment-button") !== -1 ||
      className.indexOf("dynamic-checkout") !== -1 ||
      className.indexOf("buy-now") !== -1;
  }

  function isCartCheckoutButton(button) {
    if (!button) return false;
    var text = actionText(button);
    var name = String(button.getAttribute && button.getAttribute("name") || "").toLowerCase();
    var href = String(button.getAttribute && button.getAttribute("href") || "");
    var form = button.form || button.closest && button.closest("form");
    var action = String(form && form.getAttribute("action") || "");
    var cartContext = button.closest && button.closest("cart-drawer, cart-items, .cart-drawer, .drawer, .cart, .cart__footer, .cart__ctas, [id*='CartDrawer'], [class*='cart-drawer'], [class*='cart__'], form[action*='/cart']");
    var cartLike = /\/cart(?:$|[?#/])/i.test(window.location.pathname + "/") ||
      /\/cart(?:$|[?#/])/i.test(action) ||
      Boolean(cartContext);
    var checkoutLike = name === "checkout" ||
      /\/checkout(?:$|[?#/])/i.test(href) ||
      /checkout|check out|结账|去付款|立即结账|proceed to checkout/i.test(text);
    return cartLike && checkoutLike;
  }

  function isProductPurchaseContext(button, root) {
    var path = window.location.pathname || "";
    if (button && button.matches && button.matches("[data-safes-pay-buy-now]")) return true;
    var form = button && (button.form || button.closest && button.closest("form"));
    if (form && /\/cart\/add(?:$|[?#/])/i.test(String(form.getAttribute("action") || ""))) return true;
    var buyContext = button && button.closest && button.closest("product-form, .product-form, .shopify-payment-button, .product__info-container, .product__info-wrapper, [data-product-form], [data-section-type='product']");
    if (/\/products\//i.test(path) && buyContext) return true;
    return false;
  }

  function actionText(node) {
    if (!node) return "";
    var className = typeof node.className === "string" ? node.className : "";
    return [
      node.innerText,
      node.textContent,
      node.value,
      node.getAttribute && node.getAttribute("aria-label"),
      node.getAttribute && node.getAttribute("title"),
      node.getAttribute && node.getAttribute("name"),
      node.getAttribute && node.getAttribute("data-action"),
      node.getAttribute && node.getAttribute("data-testid"),
      node.getAttribute && node.getAttribute("data-button-text"),
      className,
      node.id
    ].filter(Boolean).join(" ").replace(/\s+/g, " ").trim().toLowerCase();
  }

  function closestCheckoutAction(target) {
    var node = target && (target.nodeType === 1 ? target : target.parentElement);
    var taggedButton = node && node.closest && node.closest("[data-safes-pay-buy-now], [data-safes-pay-button], [data-piginto-cart-checkout]");
    if (taggedButton) return taggedButton;
    for (var depth = 0; node && node !== document.body && depth < 10; depth += 1, node = node.parentElement) {
      if (node.matches && node.matches("a")) {
        if (isCartCheckoutButton(node)) return node;
        continue;
      }
      if (!isButtonLikeAction(node)) continue;
      if (isBuyNowButton(node) || isCartCheckoutButton(node)) return node;
      return node;
    }
    return null;
  }

  function isCheckoutWrapperPage() {
    var path = window.location.pathname.replace(/\/+$/, "");
    return path === checkoutWrapperPath() || path === LEGACY_CHECKOUT_WRAPPER_PATH;
  }

  function checkoutFrameUrlFromCurrentPage() {
    var source = new URL(window.location.href);
    var target = new URL(checkoutProxyPath(), window.location.origin);
    source.searchParams.forEach(function (value, key) {
      target.searchParams.set(key, value);
    });
    target.searchParams.set("embed", "shopify");
    target.searchParams.set("start", "top");
    target.searchParams.set("v", VERSION);
    return target.toString();
  }

  function checkoutFrameUrlFromWrapperUrl(wrapperUrl) {
    if (!wrapperUrl) return "";
    var source = new URL(wrapperUrl, window.location.origin);
    var target = new URL(checkoutProxyPath(), window.location.origin);
    source.searchParams.forEach(function (value, key) {
      target.searchParams.set(key, value);
    });
    target.searchParams.set("embed", "shopify");
    target.searchParams.set("start", "top");
    target.searchParams.set("v", VERSION);
    return target.toString();
  }

  function currentWrapperSourceUrl() {
    var params = new URL(window.location.href).searchParams;
    return params.get("source_url") || params.get("return_url") || "";
  }

  function jsonNodeFromDocument(doc, id) {
    var node = doc && doc.getElementById && doc.getElementById(id);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || "{}");
    } catch (error) {
      return null;
    }
  }

  function checkoutUrlFromSourceProductData(data, sourceUrl, sourceDoc) {
    if (!data || !Array.isArray(data.variants) || !data.variants.length) return "";
    var variantId = "";
    try {
      variantId = new URL(sourceUrl, window.location.origin).searchParams.get("variant") || "";
    } catch (error) {}
    var enhancedData = Object.assign({}, data || {});
    if (variantId && !enhancedData.selectedVariantId) enhancedData.selectedVariantId = variantId;
    return checkoutUrlFromProductData(enhancedData, sourceDoc || document, {
      sourceName: "shopify_theme_product_fallback",
      sourceUrl: sourceUrl,
      returnUrl: sourceUrl
    });
  }

  function fetchSourceProductCheckoutFrameUrl() {
    var sourceUrl = currentWrapperSourceUrl();
    if (!sourceUrl) return Promise.resolve("");
    var parsed;
    try {
      parsed = new URL(sourceUrl, window.location.origin);
    } catch (error) {
      return Promise.resolve("");
    }
    if (parsed.origin !== window.location.origin) return Promise.resolve("");
    return fetch(parsed.toString(), {
      credentials: "same-origin",
      headers: { "Accept": "text/html,application/xhtml+xml" }
    }).then(function (response) {
      if (!response.ok) throw new Error("source_" + response.status);
      return response.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, "text/html");
      var data = jsonNodeFromDocument(doc, "SafeSPayEmbeddedCheckoutData") || jsonNodeFromDocument(doc, "PigintoProductCheckoutData");
      var wrapperUrl = checkoutUrlFromSourceProductData(data, parsed.toString(), doc);
      return checkoutFrameUrlFromWrapperUrl(wrapperUrl);
    }).catch(function () {
      return "";
    });
  }

  function checkoutFrameUrlForWrapperPage() {
    var current = new URL(window.location.href);
    if (current.searchParams.get("payload")) return Promise.resolve(checkoutFrameUrlFromCurrentPage());

    var sourceUrl = currentWrapperSourceUrl() || window.location.href;
    return fetchCartCheckoutUrl({ sourceUrl: sourceUrl, returnUrl: sourceUrl }).then(function (wrapperUrl) {
      return checkoutFrameUrlFromWrapperUrl(wrapperUrl);
    }).catch(function () {
      return "";
    }).then(function (frameUrl) {
      if (frameUrl) return frameUrl;
      return fetchSourceProductCheckoutFrameUrl();
    }).then(function (frameUrl) {
      return frameUrl || checkoutFrameUrlFromCurrentPage();
    });
  }

  function mountCheckoutWrapperPage() {
    document.body.classList.add("piginto-checkout-theme-page");
    document.title = "Secure Checkout";
    var main = document.querySelector("main") || document.body;
    var wrapper = document.createElement("section");
    wrapper.className = "piginto-checkout-wrapper";

    var frameWrap = document.createElement("div");
    frameWrap.className = "safes-embedded-checkout-frame-wrap";
    var loader = document.createElement("div");
    loader.className = "safes-embedded-checkout-loader";
    loader.innerHTML = '<div class="safes-embedded-checkout-loader-card"><span class="safes-embedded-checkout-spinner"></span><span>Loading secure checkout...</span></div>';

    var frame = document.createElement("iframe");
    frame.title = "Secure Checkout";
    frame.loading = "eager";
    frame.allow = "payment *; clipboard-read; clipboard-write; fullscreen";
    frame.referrerPolicy = "strict-origin-when-cross-origin";
    frameWrap.appendChild(frame);
    frameWrap.appendChild(loader);
    wrapper.appendChild(frameWrap);

    var loaderHidden = false;
    function hideLoader() {
      if (loaderHidden) return;
      loaderHidden = true;
      frameWrap.classList.add("safes-embedded-checkout-loaded");
      setTimeout(function () {
        if (loader && loader.parentNode) loader.parentNode.removeChild(loader);
      }, 260);
    }
    frame.addEventListener("load", function () {
      setTimeout(hideLoader, 650);
    });
    checkoutFrameUrlForWrapperPage().then(function (url) {
      frame.src = url || checkoutFrameUrlFromCurrentPage();
    }).catch(function () {
      frame.src = checkoutFrameUrlFromCurrentPage();
    });
    window.addEventListener("message", function (event) {
      var data = event && event.data;
      if (event.source !== frame.contentWindow) return;
      if (data && (data.type === "safesEmbeddedCheckoutReady" || data.type === "pigintoCheckoutReady" || data.type === "checkoutReady")) {
        hideLoader();
        return;
      }
      if (!data || (data.type !== "pigintoCheckoutResize" && data.type !== "safesCheckoutResize")) return;
      hideLoader();
      var height = Math.max(900, Math.min(4000, Number(data.height) || 0));
      if (!height) return;
      frame.style.height = height + "px";
    });

    main.innerHTML = "";
    main.appendChild(wrapper);
  }

  var isRedirecting = false;
  var checkoutTransitionMask = null;

  function showCheckoutTransition(message) {
    // Overlay removed: the jump to the embedded checkout is fast and the checkout page
    // renders an instant server-side skeleton, so no "Preparing secure checkout" mask is needed.
    return;
  }

  function hideCheckoutTransition() {
    if (!checkoutTransitionMask) return;
    if (checkoutTransitionMask.parentNode) checkoutTransitionMask.parentNode.removeChild(checkoutTransitionMask);
    checkoutTransitionMask = null;
  }

  function checkoutClickSessionId() {
    var gen = "clk_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 10);
    try {
      var existing = window.sessionStorage.getItem(CLICK_BEACON_SESSION_KEY);
      if (existing) return existing;
      window.sessionStorage.setItem(CLICK_BEACON_SESSION_KEY, gen);
      return gen;
    } catch (e) {
      return gen; // 隐私模式无 sessionStorage:退化成每次一个 id(仍能统计点击,只是不跨刷新去重)
    }
  }

  // 点了结账就上报 a_checkout_click(同会话只报一次,和 other/a_checkout 同口径去重)。keepalive 保证
  // 跳转发生也能发出;全 try/catch + catch()静默,绝不阻断跳转。
  function fireCheckoutClickBeacon() {
    if (checkoutClickBeaconFired) return;
    checkoutClickBeaconFired = true;
    try {
      var store = configuredStore(readData());
      if (!store) return;
      fetch(CLICK_TRACKING_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json", "x-tenant-id": store },
        body: JSON.stringify({
          sessionId: checkoutClickSessionId(),
          pageType: "a_checkout_click",
          pagePath: location.href,
          referrer: location.href
        }),
        keepalive: true,
        mode: "cors",
        credentials: "omit"
      }).catch(function () {});
    } catch (e) {}
  }

  function navigateToCheckout(url, message) {
    tiktokFunnel.checkout(url);
    fireCheckoutClickBeacon();
    window.location.assign(url);
  }

  function stopCheckoutEvent(event) {
    if (!event) return;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === "function") event.stopImmediatePropagation();
  }

  function setCartButtonBusy(button, busy) {
    if (!button || !button.setAttribute) return;
    if (busy) {
      button.setAttribute("aria-busy", "true");
      if (button.tagName === "BUTTON" || button.tagName === "INPUT") button.disabled = true;
    } else {
      button.removeAttribute("aria-busy");
      if (button.tagName === "BUTTON" || button.tagName === "INPUT") button.disabled = false;
    }
  }

  function redirectCartCheckout(button, event) {
    if (isRedirecting) return true;
    isRedirecting = true;
    stopCheckoutEvent(event);
    setCartButtonBusy(button, true);
    showCheckoutTransition("Preparing secure checkout...");

    var cachedUrl = cartCheckoutUrlCache;
    if (cachedUrl) {
      navigateToCheckout(cachedUrl);
      return true;
    }

    cachedCartCheckoutUrl().then(function (url) {
      if (!url) {
        isRedirecting = false;
        setCartButtonBusy(button, false);
        hideCheckoutTransition();
        return;
      }
      navigateToCheckout(url);
    }).catch(function () {
      isRedirecting = false;
      setCartButtonBusy(button, false);
      hideCheckoutTransition();
    });
    return true;
  }

  function redirectFromButton(button, event) {
    if (!button) return false;
    if (isRedirecting) {
      stopCheckoutEvent(event);
      return true;
    }

    if (isCartCheckoutButton(button)) {
      return redirectCartCheckout(button, event);
    }

    if (!isBuyNowButton(button)) return false;

    var root = contextFromButton(button);
    // Never fall through to the native Shopify checkout for a recognized buy button.
    // If we cannot resolve the product context or build the embedded checkout URL
    // (e.g. incomplete config / no payment channel), block the click instead of
    // letting the native checkout take over.
    if (!isProductPurchaseContext(button, root)) {
      stopCheckoutEvent(event);
      return true;
    }
    var data = readData();
    var url = data && Array.isArray(data.variants) && data.variants.length
      ? checkoutUrlFromProductData(data, root)
      : checkoutUrlFromDom(root);
    if (!url) {
      stopCheckoutEvent(event);
      return true;
    }

    isRedirecting = true;
    stopCheckoutEvent(event);
    navigateToCheckout(url, "Preparing secure checkout...");
    return true;
  }

  function bindQuickBuyClicks() {
    function handleEvent(event) {
      var target = event.target;
      var button = closestCheckoutAction(target);
      redirectFromButton(button, event);
    }

    var activeCapture = { capture: true, passive: false };
    window.addEventListener("pointerdown", handleEvent, activeCapture);
    window.addEventListener("touchstart", handleEvent, activeCapture);
    window.addEventListener("mousedown", handleEvent, activeCapture);
    window.addEventListener("click", handleEvent, activeCapture);

    document.addEventListener("submit", function (event) {
      var form = event.target;
      var action = String(form && form.getAttribute && form.getAttribute("action") || "");
      if (/\/cart\/add(?:$|[?#/])/i.test(action)) invalidateCartCheckoutUrl();
      var button = event.submitter || form && form.querySelector && form.querySelector("[name='checkout'], button[type='submit'], input[type='submit']");
      redirectFromButton(button, event);
    }, true);
  }

  function rewriteCartCheckoutControls() {
    var controls = document.querySelectorAll("a, button, input[type='submit'], input[type='button'], [role='button']");
    var found = false;
    for (var i = 0; i < controls.length; i += 1) {
      var control = controls[i];
      if (!isCartCheckoutButton(control)) continue;
      found = true;
      control.setAttribute("data-piginto-cart-checkout", "1");
      if (control.tagName === "A") {
        control.setAttribute("href", cartCheckoutUrlCache || "#");
      }
      var form = control.form || control.closest && control.closest("form");
      if (form) form.setAttribute("data-piginto-cart-checkout", "1");
    }
    if (found && !cartCheckoutUrlCache && !cartCheckoutUrlPromise) warmCartCheckoutUrl();
  }

  function scheduleCartRewrite() {
    clearTimeout(cartRewriteTimer);
    cartRewriteTimer = setTimeout(function () {
      rewriteCartCheckoutControls();
      if (document.querySelector("[data-piginto-cart-checkout]")) warmCartCheckoutUrl();
    }, 80);
  }

  var pending = 0;
  function scheduleUpdate() {
    clearTimeout(pending);
    pending = setTimeout(function () {}, 120);
  }

  function init() {
    try { tiktokFunnel.install(); } catch (e) {}
    injectStyle();
    if (isCheckoutWrapperPage()) {
      mountCheckoutWrapperPage();
      return;
    }
    bindQuickBuyClicks();
    rewriteCartCheckoutControls();
    if (/\/cart(?:$|[?#/])/i.test(window.location.pathname + "/")) warmCartCheckoutUrl();
    if (window.MutationObserver) {
      new MutationObserver(scheduleCartRewrite).observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["class", "open", "aria-hidden", "style"]
      });
    }
    document.addEventListener("change", scheduleUpdate, true);
    document.addEventListener("change", invalidateCartCheckoutUrl, true);
    document.addEventListener("input", function (event) {
      scheduleUpdate();
      if (event && event.target && String(event.target.getAttribute && event.target.getAttribute("name") || "").toLowerCase() === "quantity") {
        invalidateCartCheckoutUrl();
      }
    }, true);
    document.addEventListener("cart:updated", function () {
      invalidateCartCheckoutUrl();
      scheduleCartRewrite();
    });
    document.addEventListener("variant:change", scheduleUpdate);
    document.addEventListener("variantChange", scheduleUpdate);
    document.addEventListener("shopify:section:load", scheduleUpdate);
    window.addEventListener("popstate", scheduleUpdate);
    // 返回/前进(尤其浏览器 bfcache 把整页连同遮罩 DOM + isRedirecting 状态原样恢复)时,
    // 强制清掉离开前显示的"Preparing secure checkout"遮罩并复位,否则遮罩会卡死在产品落地页上。
    window.addEventListener("pageshow", function () {
      isRedirecting = false;
      hideCheckoutTransition();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
